export default "/images/vendor/flag-icons/flags/4x3/fj.svg?3f46c20e700872e4d3e0968ebd0953c4";